var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#check_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.725 1.386c1.534-.171 3.135-.321 4.775-.321 1.64 0 3.241.15 4.775.32 2.389.267 4.308 2.185 4.564 4.577.163 1.527.304 3.117.304 4.746 0 1.629-.14 3.219-.304 4.745-.256 2.393-2.175 4.31-4.564 4.577-1.534.17-3.135.32-4.775.32-1.64 0-3.241-.15-4.775-.32-2.389-.267-4.308-2.184-4.564-4.577-.163-1.526-.304-3.116-.304-4.745 0-1.63.14-3.22.304-4.746.256-2.392 2.175-4.31 4.564-4.576Zm8.946 6.412a.893.893 0 1 0-1.2-1.323c-1.186 1.077-2.078 2.044-2.83 3.219-.548.855-1.01 1.8-1.461 2.945l-1.61-1.66a.893.893 0 0 0-1.282 1.243l2.597 2.679a.893.893 0 0 0 1.484-.328c.6-1.725 1.133-2.914 1.775-3.916.639-.996 1.409-1.845 2.527-2.86Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "check_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5 .708)",
  d: "M0 0h20v20H0z"
})))));
export default SvgCheck;